import React from "react";
import SetupCard from "src/pages/GetStarted/Onboarding/SetupCard";
import { useSelector } from "react-redux";
import { getAllSales } from "src/store/sale/selector";
import connectBankIcon from "src/assets/onboarding/connectBank.svg";
import { completeUserSetupQuestionCardBank } from "src/apiService/modules/users";

const ConnectBanksCard = ({
  onClick,
  completed = false,
  skipDataGate = false,
}) => {
  const sales = useSelector(getAllSales);
  const disabled = !skipDataGate && !sales.length;

  return (
    <SetupCard
      title="Connect Bank(s)"
      imageSrc={connectBankIcon}
      description="Click to connect your bank/credit card."
      buttonText="Connect Bank/Credit Card"
      onButtonClick={onClick}
      points={15}
      disabled={disabled}
      tooltipText={
        disabled
          ? "Connect an account and import data to complete this step."
          : undefined
      }
      completed={completed}
      onManualComplete={() =>
        completeUserSetupQuestionCardBank({ source: "user-dismissed" })
      }
    />
  );
};

export default ConnectBanksCard;
